import React, { Fragment, useRef, useEffect } from "react";
import "../../../ui-styles/sliders/RightFullSlider.css";
import "../../../ui-styles/chat/chat.css";

const ChatListItem = (props) => {
    const { data, sub, keyId } = props;
    const msgRef = useRef(null);

    useEffect(() => {
        let ele = msgRef.current;
        if (ele) {
            ele.scrollIntoView(
                {
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'nearest'
                });
        }
    },[data]);
    return <Fragment key={keyId}>
            {sub === data.userId ?
                <li className="chatMsg sent" ref={msgRef}>
                    <span>{data.message}</span>
                    <span className="metadata">
                        <small className="time white">{new Date(data.createdAt).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}</small>
                    </span>
                </li>
                : <li className="chatMsg received" ref={msgRef}>
                    <span className="name">{data.name ? data.name : ''}</span>
                    <div>
                        <span>{data.message}</span>
                        <span className="metadata">
                            <small className="time">{new Date(data.createdAt).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}</small>
                        </span>
                    </div>
                </li>
            }
    </Fragment>

}

export default React.memo(ChatListItem);